import { sushiSwapModule } from './sushiSwapModule'

export default sushiSwapModule
